import React, { useState } from 'react';
import { Box, Typography, Paper, Chip, Collapse, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import TableChartIcon from '@mui/icons-material/TableChart';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface CsvSummaryBannerProps {
  headers: string[];
  data: Record<string, string>[];
}

const CsvSummaryBanner: React.FC<CsvSummaryBannerProps> = ({ headers, data }) => {
  const [expanded, setExpanded] = useState(false);
  const previewRows = data.slice(0, 3);

  if (!data.length) return null;

  return (
    <Paper variant="outlined" sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1.5, flexWrap: 'wrap' }}>
        <TableChartIcon color="action" fontSize="small" />
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          CSV cargado:
        </Typography>
        <Chip label={`${data.length} fila${data.length !== 1 ? 's' : ''}`} size="small" color="primary" variant="outlined" />
        <Chip label={`${headers.length} columna${headers.length !== 1 ? 's' : ''}`} size="small" color="primary" variant="outlined" />
        <IconButton size="small" onClick={() => setExpanded((e) => !e)} sx={{ ml: 'auto' }}>
          <ExpandMoreIcon sx={{ transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.2s' }} />
        </IconButton>
      </Box>
      <Collapse in={expanded}>
        <TableContainer sx={{ maxHeight: 250 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {headers.map((h) => (
                  <TableCell key={h} sx={{ fontWeight: 600, bgcolor: 'grey.100' }}>
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {previewRows.map((row, i) => (
                <TableRow key={i} hover>
                  {headers.map((h) => (
                    <TableCell key={h} sx={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {row[h] ?? ''}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {data.length > 3 && (
          <Typography variant="caption" color="textSecondary" sx={{ display: 'block', p: 1 }}>
            Mostrando 3 de {data.length} filas.
          </Typography>
        )}
      </Collapse>
    </Paper>
  );
};

export default CsvSummaryBanner;
